var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEyeOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#9e9e9e",
    d: "M13 6.158a10.712 10.712 0 0 1 9.622 5.742 10.145 10.145 0 0 1-2.629 3.258l1.538 1.473A12.341 12.341 0 0 0 25 11.9a12.9 12.9 0 0 0-12-7.831 13.456 13.456 0 0 0-3.971.6l1.8 1.723A11.5 11.5 0 0 1 13 6.158zm-1.167 1.19l2.258 2.162a2.67 2.67 0 0 1 1.4 1.337l2.258 2.162a4.691 4.691 0 0 0 .153-1.117 4.883 4.883 0 0 0-6.065-4.543zM2.1 3.933l2.924 2.8A12.318 12.318 0 0 0 1 11.9a12.9 12.9 0 0 0 12 7.833 13.3 13.3 0 0 0 4.713-.856l3.731 3.572 1.538-1.473L3.64 2.45zm8.182 7.833l2.847 2.726a.57.57 0 0 1-.131.021 2.672 2.672 0 0 1-2.725-2.613c0-.051.011-.082.011-.134zM6.575 8.215l1.909 1.828a4.628 4.628 0 0 0-.393 1.857A4.815 4.815 0 0 0 13 16.6a5.113 5.113 0 0 0 1.931-.376L16 17.249a11.855 11.855 0 0 1-3 .4A10.712 10.712 0 0 1 3.378 11.9a10.46 10.46 0 0 1 3.2-3.687z",
    transform: "translate(-1 -2.45)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEyeOff);
export default __webpack_public_path__ + "static/media/icon-eye-off.4f7230ad.svg";
export { ForwardRef as ReactComponent };